'use strict'

const values_ = require('lodash/values')
const map_ = require('lodash/map')
const pickBy_ = require('lodash/pickBy')
const uniq_ = require('lodash/uniq')
const maybe = require('folktale/maybe')

const getReferencedCollection = field => field.referencedCollection

module.exports = schema =>
  maybe
    .fromNullable(schema.fields)
    .map(fields => pickBy_(fields, getReferencedCollection))
    .map(values_)
    .map(refFields => map_(refFields, getReferencedCollection))
    .map(uniq_)
    .getOrElse(maybe.Nothing())



// WEBPACK FOOTER //
// ./helpers/getReferencedCollectionsNames.js